import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getTeam } from '../redux/teamSlice';

const Team = () => {
  const dispatch = useDispatch();
  const { data: team = [], status } = useSelector((state) => state.team);

  useEffect(() => {
    if (status === 'idle') {
      dispatch(getTeam());
    }
  }, [dispatch, status]);

  useEffect(() => {
    if (status === 'succeeded') {
      // console.log('Team list:', team);
    }
  }, [status, team]);

  return (
    <div className="row">
      <div className="col-12 text-center">
        <h2 className='heading mt-3 mt-md-4 mt-lg-4 mt-xl-4'>Our Team</h2>
        <p className='sub-desc mb-1 mb-md-4 mb-lg-4 mb-xl-4'>100+ Years of Collective wisdom</p>
      </div>
      <div className="col-12 ps-3 pe-3">
        {status === 'loading' && <p>Loading...</p>}
        {status === 'failed' && <p>Failed to load team.</p>}
        {status === 'succeeded' && team.length === 0 && <p>No team members available.</p>}
        {status === 'succeeded' && team.length > 0 && (
          <div className='container p-0'>
            <div className='row'>
              {team.map((member) => (
                <div className='col-6 col-md-6 col-sm-6 col-lg-3 col-xl-3 p-2 p-md-3 p-lg-3 p-xl-3' key={member.member_id}>
                  <div className='team-card'>
                    <div className='row'>
                      <div className='col-12 col-md-12 profile-image'>
                        <img src={member.member_image} className='img-fluid' />
                      </div>
                      <div className='col-12 col-md-12 team-info'>
                        <h3>{member.member_name}</h3>
                        <h6>{member.member_edu}</h6>
                        {member.member_company_name && (
                          <p>
                            {member.is_founder && <span style={{ fontWeight: 'bold' }}>Founder:</span>} {member.member_company_name}
                          </p>
                        )}
                        {member.member_degn && <p>{member.member_degn}</p>}
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Team;